import { createApp } from 'vue';
import piniaPersistedstate from 'pinia-plugin-persistedstate'
import { createPinia } from 'pinia';
import mitt from 'mitt';

import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css'
import "bootstrap"
import '@/assets/style.scss';

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'

import App from './App.vue';
import router from './router';

const pinia = createPinia()
pinia.use(piniaPersistedstate)

const emitter = mitt();

// Включаем обновление локали для ElementPlus
import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import 'dayjs/locale/ru';

dayjs.extend(updateLocale);
dayjs.updateLocale('ru', {
  weekStart: 1, // Понедельник
});

const app = createApp(App);
app.use(pinia)
app.use(router);

import {customRu} from "@/helpers/elCustomLocale";
app.use(ElementPlus, {locale: customRu,})



app.provide('emitter', emitter)
app.mount('#app');

import { useStore } from "@/store";
const store = useStore()
store.setLoaded()
store.applyTheme()


